var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{ref:"modalTerms",attrs:{"hide-footer":"","centered":""},on:{"hidden":_vm.hide},model:{value:(_vm.showModal),callback:function ($$v) {_vm.showModal=$$v},expression:"showModal"}},[_c('div',{staticClass:"mb-4 scroll-policy"},[_c('div',{staticClass:"mt-3",domProps:{"innerHTML":_vm._s(_vm.policy)}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }